import { render, staticRenderFns } from "./Form2FASettings.vue?vue&type=template&id=dff7c950&scoped=true"
import script from "./Form2FASettings.vue?vue&type=script&lang=js"
export * from "./Form2FASettings.vue?vue&type=script&lang=js"
import style0 from "./Form2FASettings.vue?vue&type=style&index=0&id=dff7c950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff7c950",
  null
  
)

export default component.exports